import { render } from "./SortProjects.vue?vue&type=template&id=e2ed439c"
import script from "./SortProjects.vue?vue&type=script&lang=js"
export * from "./SortProjects.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__